import {WishlistSortOptions} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/wishlist/v1/page/service.types';

export const mapSortToWishlistSort = (sort?: string): WishlistSortOptions => {
  switch (sort) {
    case 'price_high':
      return WishlistSortOptions.HIGHEST_PRICE;
    case 'price_low':
      return WishlistSortOptions.LOWEST_PRICE;
    case 'highest_reduction':
      return WishlistSortOptions.HIGHEST_REDUCTION;
    case 'low_stock':
      return WishlistSortOptions.LOW_STOCK;
    default:
      return WishlistSortOptions.UNSPECIFIED;
  }
};
